export default __webpack_public_path__ + "static/media/trademark001.e4221e2d.png";